import Vuex from 'vuex'
import Vue from 'vue'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

// Modules
import AppModule from './modules/app'
import SubjectsModule from './modules/subjects'
import ItemsModule from './modules/items'
import LessonsModule from './modules/lessons'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        auth: null,
        refererRouteLogin: null,
        userLoggedIn: null,
        runRefreshToken: false
    },
    actions,
    getters,
    // state changes
    mutations,
    modules: {
        app: AppModule,
        subjects: SubjectsModule,
        items: ItemsModule,
        lessons: LessonsModule
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js